import { Box, Stack, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { X } from 'lucide-react';
import React from 'react';
import { ButtonStd } from './ButtonStd';
import CardTitle from './CardTitle';
import HandleTop from './HandleTop';
import WindowBackground from './WindowBackground';

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm action',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  width = '700px',
  messageIcon = null,
  singleButton = false, // If true, only show confirm button
}) => {
  return (
    <Dialog
      open={Boolean(open)}
      onClose={onClose}
      maxWidth={false}
      slotProps={{
        paper: {
          sx: {
            background: 'transparent',
            boxShadow:
              '0 33px 9px 0 rgba(67, 79, 86, 0.01), 0 21px 8px 0 rgba(67, 79, 86, 0.07), 0 12px 7px 0 rgba(67, 79, 86, 0.25), 0 5px 5px 0 rgba(67, 79, 86, 0.43), 0 1px 3px 0 rgba(67, 79, 86, 0.49)',
            width,
            borderRadius: '20px',
          },
        },
      }}
    >
      <Stack direction="column" alignItems="center" gap="1px">
        <HandleTop onIconClick={onClose} iconAriaLabel="Close dialog">
          <X />
        </HandleTop>
        <WindowBackground radius="20px">
          <CardTitle title={title}>
            <Box
              sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mt: 2 }}
            >
              <Stack direction="row" alignItems="center" gap={1}>
                {messageIcon}
                {typeof message === 'string' ? (
                  <Typography variant="body1" sx={{ textAlign: 'center' }}>
                    {message}
                  </Typography>
                ) : (
                  message
                )}
              </Stack>
              <Stack direction="row" spacing={2} sx={{ mt: 3 }} justifyContent="center">
                {!singleButton && (
                  <ButtonStd width="160px" onClick={onClose}>
                    {cancelText}
                  </ButtonStd>
                )}
                <ButtonStd width="160px" onClick={onConfirm}>
                  {confirmText}
                </ButtonStd>
              </Stack>
            </Box>
          </CardTitle>
        </WindowBackground>
      </Stack>
    </Dialog>
  );
};

export default ConfirmDialog;
